export default "__VITE_ASSET__CVVMumTB__"